module.exports = "<app-navbar></app-navbar>\n<main>\n    <div id=\"contenedorInicial\" class=\"container\" >\n        <router-outlet>\n            <block-ui [template]=\"blockTemplate\" [delayStop]=\"500\"> </block-ui>\n        </router-outlet>\n    </div>\n</main>\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contenedor.component.html
// module id = ./src/app/components/contenedor.component.html
// module chunks = main